import script from "./AddInfoMandateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddInfoMandateModal.vue?vue&type=script&setup=true&lang=js"

import "./AddInfoMandateModal.vue?vue&type=style&index=0&id=4a38a9be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a38a9be"]])

export default __exports__